import {Profile} from '@/domain/entities/Profile';
import {Precinct} from '@/domain/entities/Precinct';
import {Parcel} from '@/domain/entities/Parcel';

export type ViewportType = {
  latitude: number,
  longitude: number,
  zoom: number,
  bearing: number,
  pitch: number
}

export type TypeChartData = {
  uuid: string,
  totalAreaInHa: number
}

export type DashboardData = {
  use: Array<TypeChartData>
  crop: Array<TypeChartData>
  soilOrganicCarbonTotal: number,
  enpProtectedAreaTotalInHa: number,
  rnProtectedAreaTotalInHa: number,
  mabProtectedAreaTotalInHa: number,
  protectionTypeNoAreaTotalInHa: number
}

export type StringIdOption = {
  id: string,
  label: string
}

export type UuidOption = {
  uuid: string,
  name: string
}

export type UuidOptionColor = {
  uuid: string,
  name: string,
  color: string
}

export enum ViewBy {
  DEFAULT = 'default',
  CROP = 'crop',
  USE = 'use',
  USER = 'user'
}

export type Crop = UuidOptionColor
export type Use = UuidOptionColor
export type Municipality = UuidOption

export type Manifest = {
  availableYears: Array<number>,
  crops: Array<Crop>,
  municipalities: Array<Municipality>,
  uses: Array<Use>,
  enpTypes: Array<string>,
  rnTypes: Array<string>,
  mabNames: Array<string>
}

export type FilterGroup = {
  userUuid?: string,
  municipalityUuid?: string,
  cropUuid?: string,
  useUuid?: string
  protectionType?: string,
  enpType?: string,
  rnType?: string,
  isMab?: 'YES' | 'NO',
}

export type bboxType = {
  xmin: number,
  ymin: number,
  xmax: number,
  ymax: number
}

export type FilteredPrecinctsType = {
  ids: Array<number>,
  bbox: bboxType | null
}

interface Clas {
  manifest: (token: string) => Promise<Manifest>
  profile: (token: string) => Promise<Profile>
  getPrecinctByPointOfInterest: (year: number, pointOfInterest: string, token: string) => Promise<Array<Precinct>>
  getParcelByPointOfInterest: (year: number, pointOfInterest: string, token: string) => Promise<Array<Parcel>>
  editPrecinct: (newPrecinct: Partial<Precinct>, token: string) => Promise<Partial<Precinct>>
  getDashboardData: (year: number, filterGroup: FilterGroup, token: string) => Promise<DashboardData>
  getFilteredPrecincts: (year: number, filterGroup: FilterGroup, token: string) => Promise<FilteredPrecinctsType>
  getUsers: (token: string) => Promise<Array<Profile>>
}

export default Clas;